var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',[_vm._t("default"),_vm._v(" "),_c('span',{staticClass:"material-icons"},[_vm._v("open_in_new")])],2)}
var staticRenderFns = []

export { render, staticRenderFns }